<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-05 10:49:19
 * @Description: 总览页面
 * @FilePath: \sheyang\src\views\overView\index.vue
-->
<template>
  <div class="overview">
    <div class="left-content">
      <!-- 当前充电情况 -->
        <current-charging-state @handleNavGo="goToChargingPage" />
        <device-number :deviceNumber="deviceNumber" />
        <!-- 今日统计 -->
        <today-stat :todayData="pvStats" @handleNavGo="goToChargingPage"/>
      <!-- 场站信息 - 充电排行榜 -->
      <station-rank :rankData="pvStats.rankList" :totalList="stationTableData" />
       <!-- <station-info-table :tableData="stationTableData" /> -->
    </div>
    <div class="center-content">
      <div class="center-top">
        <over-view-data :overViewData="powerStatData" />
      </div>
      <!-- <center-map /> -->
      <div id="map">
        <a-map />
      </div>
      <div class="carbon">
        <total-carbon-reduction :totalCarbonReductionData="powerStatData.reduction" />
      </div>
    </div>
    <div class="right-content">
      <!-- 累计用电量 & V2G 放电量 -->
      <cumulative-ele
        :dateData="monthAnysDate"
        :eleData="monthChargingPowerData"
        :dischargeData="monthDisChargingPowerData"
        @handleNavGo="goToChargingPage"
      />
      <div class="total-container">
        <!-- <div class="item">
          <span class="label">累计用电量</span>
          <div class="value-container">
            <span class="value">{{ storedChargingAmount | toNumber }}</span>
            <span class="unit">MWh</span>
          </div>
        </div> -->
        <div class="item">
          <span class="label">V2G放电量</span>
          <div class="value-container">
            <span class="value">{{ storedDisChargingAmount | toNumber }}</span>
            <span class="unit">MWh</span>
          </div>
        </div>
      </div>
      <!-- <today-ele-info
        :greenEnergyData="pvPowerGeneration"
        :gridEnergyData="chargingAmount"
        @handleNavGo="goToPvPage"
      /> -->
      <!-- <station-info-table :tableData="stationTableData" /> -->
      <!-- :totalPvPower="totalPvPower" -->
      <ev-ele-stat
        :dateData="monthAnysDate"
        :pvPowerData="monthPvPowerData"
        :totalPvPower="totalPvPower"
        @handleNavGo="goToPvPage"
      />
      <!-- <total-carbon-reduction :totalCarbonReductionData="powerStatData.reduction" /> -->
      <recent-month-power
        :chargingInfo="chargingInfo"
        @handleNavGo="goStoragePage"
      />

    </div>
    <station-charge-modal :visible="openStationDialog" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
// 当前充电状况
import currentChargingState from '@/module/chargingStats/leftContent/currentChargingState.vue';
// 场站数量等数据
import deviceNumber from '@/module/chargingStats/deviceNumber.vue';
import cumulativeEle from '@/module/overview/leftContent/cumulativeE.vue'; // 累计用电量
import evEleStat from '@/module/overview/rightContent/evEleStat.vue'; // 光伏发电量统计
// import todayEleInfo from '@/module/overview/rightContent/todayEleInfo.vue'; // 今日场站用电情况
// 碳减排
import totalCarbonReduction from '@/module/overview/rightContent/totalCarbonReduction.vue'; // 累计减碳
import recentMonthPower from '@/module/energyStorage/rightContent/recentMonthPower.vue'; // 近30日
import overViewData from '@/module/overview/centerContent/overViewData.vue'; // 中部数据汇总组件
import todayStat from '@/module/energyStorage/leftContent/toadyStat.vue'; // 今日充电统计
// 充电站充电排行榜
import stationRank from '@/module/overview/stationRank.vue';
// 单场站充电弹框
import stationChargeModal from '@/module/overview/stationChargeModal/index.vue';
import AMap from '@/module/aMap/index.vue';
import { getChargeStatus, getDataStatistics } from '@/api/stationStatistics';
import { toDecimal, toInteger } from '@/utils';

let timer = null;

export default {
  name: 'overView',
  components: {
    todayStat,
    deviceNumber,
    currentChargingState,
    cumulativeEle,
    evEleStat,
    recentMonthPower,
    overViewData,
    totalCarbonReduction,
    stationRank,
    stationChargeModal,
    AMap,
  },
  filters: {
    // 保留一位小数 String
    toNumber(val) {
      return val ?Number(val).toFixed(0) : '0';
    },
  },
  data () {
    return {
      todayData: [
        {
          title: '尖',
          icon: require('@/assets/images/chargingStatistics/jianIcon.png'),
          bg: require('@/assets/images/chargingStatistics/jianBg.png'),
        },
        {
          title: '峰',
          icon: require('@/assets/images/chargingStatistics/fengIcon.png'),
          bg: require('@/assets/images/chargingStatistics/fengBg.png'),
        },
        {
          title: '平',
          icon: require('@/assets/images/chargingStatistics/pingIcon.png'),
          bg: require('@/assets/images/chargingStatistics/pingBg.png'),
        },
        {
          title: '谷',
          icon: require('@/assets/images/chargingStatistics/guIcon.png'),
          bg: require('@/assets/images/chargingStatistics/guBg.png'),
        },
      ],
      // 今日光伏发电功率数据
      todayPvPower: {
        xAxisDate: [],
        powerData: [],
      },
      // 月光伏发电量数据
      monthPvPower: {
        xAxisDate: [],
        powerData: [],
      },
      pVDataPower: {
        ad: '1',
        data: [],
        index: [],
      },
      stationTableData: [],
      statisticsData: {},
    };
  },
  computed: {
    ...mapState({
      openStationDialog: (state) => state.global.openStationDialog,
    }),
    ...mapGetters([
      'stationList',
    ]),
    ...mapGetters('overView', [
      'pvStats',
      'chargingInfo',
      'powerStatData',
      'monthAnysDate',
      'monthPvPowerData',
      'totalPvPower',
      'monthChargingPowerData',
      'monthDisChargingPowerData',
    ]),
    ...mapGetters({
      stationNum: 'stationNum',
      equipmentAmount: 'equipmentAmount',
    }),
    pvPowerGeneration () {
      return this.powerStatData.pvPowerGeneration;
    },
    chargingAmount () {
      return this.powerStatData.chargingAmount;
    },
    storedChargingAmount() {
      return `${(this.powerStatData.storedChargingAmount / 1000).toFixed(1)}`;
    },
    storedDisChargingAmount() {
      return `${(this.powerStatData.storedDisChargingAmount / 1000).toFixed(1)}`;
    },
    deviceNumber () {
      return {
        stationNum: this.stationNum,
        equipmentAmount: this.equipmentAmount,
        ac: this.statisticsData.acTotalCnt || 0,
        dc: this.statisticsData.dcTotalCnt || 0,
      };
    },
  },
  watch: {
    pvStats(val) {
      this.todayPvPower.powerData = val.pvPowerList;
      this.pVDataPower.data = val.pvPowerGenerationList;
    },
    stationList(val) {
      if (val.length === 0 && !val) return;
      // 获取所有的 eletric 取总值
      const total = val.reduce(
        (acc, cur) => acc + cur.electric,
        0,
      );
      const newData = val.map((item) => ({
        ...item,
        rate: ((Number(item.electric) / total) * 100).toFixed(2),
      }));
      newData.sort((a, b) => b.electric - a.electric);
      this.stationTableData = [...newData];
    },
  },
  mounted () {
    this.timerRequestData();
  },
  beforeDestroy () {
    if (timer) {
      // 清除定时器
      clearInterval(timer);
    }
  },
  methods: {
    ...mapActions({
      getEquipmentNum: 'getEquipmentNum', // 获取设备数量
      changeNavItemsActive: 'changeNavItemsActive',
      getOverViewPowerStatData: 'overView/getOverViewPowerStatData', // 获取总览页面光伏统计数据
      getMonthAnalyseData: 'overView/getOverViewMonthAnalyseData', // 获取月分析数据
      getPvStats: 'overView/rankAndYesterdayOrTodayData', // 获取光伏统计数据
    }),
    fetchOverViewData () {
      this.getEquipmentNum();
      this.getOverViewPowerStatData();
      this.getMonthAnalyseData();
      this.getPvStats();
      this.fetchDataStatistics();
    },
    // 获取充电站总数等统计信息
    async fetchDataStatistics () {
      const statisticRes = await getDataStatistics();
      const statusRes = await getChargeStatus();
      if (statisticRes.code === '200' && statisticRes.data) {
        const { reduction, chargingAmount } = statisticRes.data;
        this.statisticsData = statisticRes.data;
        this.statisticsData.reduction = toDecimal(reduction);
        this.statisticsData.chargingAmount = toInteger(chargingAmount);
      }
      if (statusRes.code === '200' && statusRes.data) {
        const { adcCharging } = statusRes.data;
        this.statisticsData.adcCharging = adcCharging;
        this.statisticsData.totalCount = this.totalCount;
        this.statisticsData.acTotalCnt = statusRes.data.acTotalCnt;
        this.statisticsData.dcTotalCnt = statusRes.data.dcTotalCnt;
      }
    },
    // 定时请求数据
    timerRequestData (seconds = 120) {
      this.fetchOverViewData();
      timer = setInterval(() => {
        this.fetchOverViewData();
      }, 1000 * seconds);
    },
    // 保留一位小数
    toDecimal(val) {
      return val ? val.toFixed(0) : '0';
    },
    // 点击跳转到充电统计页面
    goToChargingPage() {
      this.changeNavItemsActive('/chargingStats');
      this.$router.push({
        path: '/chargingStats',
      });
    },
    // 点击跳转到光伏统计页面
    goToPvPage() {
      this.changeNavItemsActive('/pvStats');
      this.$router.push({
        path: '/pvStats',
      });
    },
    // 点击跳转到储能统计页面
    goStoragePage() {
      this.changeNavItemsActive('/energyStorageStats');
      this.$router.push({
        path: '/energyStorageStats',
      });
    },
  },
};
</script>

<style lang="less" scoped>
.overview {
  width: 1920px;
  height: 100%;
  display: grid;
  grid-template-columns: 456px 1008px 456px;
  grid-template-rows: 100%;

  .left-content {
    z-index: 2;
    box-sizing: border-box;
    padding-top: 24px;
    padding-left: 19px;
    .displayFlex();
    flex-direction: column;
  }

  .overview-sys-info {
    // 下钻组件类名
    margin-top: 32px;
    padding-bottom: 0px;
    ::v-deep .pub-info-title {
      margin-bottom: 0px;
    }
    ::v-deep .pub-info-list-item {
      margin-bottom: 0px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .sys-content {
      padding-left: 18px;
    }
  }

  .charging-content {
    width: 100%;
    margin-top: 33px;
    display: flex;
    .sys-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        margin-top: 21px;
        width: 72px;
        height: 26px;
        margin-bottom: 27px;
      }
      .sys-bg {
        width: 110px;
        height: 134px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        .sys-info {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          height: 30px;
          width: 150px;
          margin: 36px 36px;
        }
        .sys-info.fgc1 {
          color: #FF7442
        }
        .sys-info.fgc2 {
          color: #ff5454;
        }
        .sys-info.fgc3 {
          color: #ffbf39;
        }
        .sys-info.fgc4 {
          color: #6efbff;
        }
        p {
          font-size: 30px;
          height: 30px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          margin-right: 5px;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }

  .center-content {
    position: relative;
    z-index: 0;
    .carbon {
      position: absolute;
      bottom: 0;
      right: 50%;
      transform: translateX(50%);
    }
    #map {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
  }

  .right-content {
    z-index: 1;
    box-sizing: border-box;
    padding-top: 24px;
    padding-right: 22px;
    .displayFlex();
    flex-direction: column;

    .total-container {
      width: 100%;
      margin-top: 18px;
      margin-bottom: 20px;
      .displayFlex(space-between);
      .item {
        width: 368px;
        margin-left: 17px;
        height: 42px;
        padding: 0px 21px 0px 14px;
        .displayFlex(space-between, center);
        background-image: url('@/assets/images/infoBg.png');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        .label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #CCCCCC;
        }
        .value-container {
          display: flex;
          align-items: center;
          .value {
            font-size: 24px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #FFFFFF;
          }
          .unit {
            margin-left: 6px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }
    };
  }
}
</style>
